import {useEffect, useState} from "react";
import {WorkClassDocument} from "../../../types/pj1dbApiWork";
import {FindModelResponse} from "../../../types/pj1dbApiHandling";
import {findHandlingWorkModels} from "../../../utils/awsAmplifyUtil";

export interface UseRepresentativeModelProps {
  workClasses: WorkClassDocument[];
  acquiredRepresentativeModels: FindModelResponse[];
}

export default function useRepresentativeModel(props: UseRepresentativeModelProps) {
  const [instanceIds, setInstanceIds] = useState<string[]>([]);
  const [models, setModels] = useState<FindModelResponse[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const deps = props.acquiredRepresentativeModels.map(model => model.modelId).sort().toString()
    + props.workClasses.map(workClass => workClass.instanceModelRelation).sort().toString();
  useEffect(() => {
    const instances = props.workClasses
      .flatMap(workClass => Object.entries(workClass.instanceModelRelation ?? {}))
      .filter(([, modelIds]) => modelIds.length > 0)
      .filter(([, modelIds]) => !modelIds.some(
        modelId => props.acquiredRepresentativeModels.some(workModel => workModel.modelId === modelId))
      )
      .map(([instanceId]) => instanceId)
      .sort();
    setInstanceIds(instances);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deps]);

  useEffect(() => {
    setIsLoading(true);
    // OPTIMIZE: インスタンスごとに取得される
    Promise.all(instanceIds.map((instanceId) => findHandlingWorkModels({instanceId})))
      .then(results => {
        setModels(Array.from(
          new Map(
            [
              ...props.acquiredRepresentativeModels,
              ...results
                .map(workModel => workModel.data)
                .flat()
                .filter((workModel): workModel is FindModelResponse => workModel !== undefined)
            ].map(workModel => [workModel.modelId, workModel])
          ).values()
        ));
      }).catch(console.error)
      .finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instanceIds.sort().toString()]);

  return {models, isLoading};
}
